module.exports = __webpack_public_path__ + "img/3xu-b48x100_2.prt.d169e1d0.jpg";